import { secureGet, securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export type PreferenceView = {
  purpose: "SURVEY_INVITATION" | "REWARD_ACCOUNT" | "PROMOTIONAL";
  label: string;
  description: string;
  granted: boolean;
  status: "GRANTED" | "DENIED" | "WITHDRAWN" | "NONE";
  updatedAt: string | null;
};

/**
 * Note there is no userId parameter on any of these.
 *
 * Identity comes from the session server-side. Accepting one from the client was
 * the shape of the D2 IDOR, and a preference endpoint is exactly where it would
 * reappear.
 */
export const getEmailPreferences = async () => secureGet("/api/consent/preferences", {});

export const updateEmailPreferences = async (
  preferences: Partial<Record<PreferenceView["purpose"], boolean>>
) => securePost("/api/consent/preferences", { preferences });

export const getConsentHistory = async () => secureGet("/api/consent/history", {});
